import EngineModule from '../EngineModule';

export default () => EngineModule.all.find(x => x.id === 'oms-customerModal') || new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'oms-customerModal',
	dependencies :     [
		'oms-basket'
	],
	allowedCustomers : null,
	generateComponentConfiguration() {
		return {};
	},
	insertionPath : null
});
